import {api} from 'services/api';
import {Color} from 'types/colors';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const updateWebColor = api.injectEndpoints({
  endpoints: builder => ({
    updateWebColor: builder.mutation<Response, UpdateColorRequest>({
      query: params => {

        return {
          method: 'PUT',
          url: `color-webs/${params.id}`,
          body: {
            name: params.name,
            code: params.code,
          },
        };
      },
    }),
  }),
});

export type UpdateColorRequest = {
  id?: ObjectId;
  name: {
    fr?: string;
    en?: string;
  };
  code?: string;
};

type Response = ResponseData<Color>;

export const {useUpdateWebColorMutation} = updateWebColor;
